var map = {
	"./en/base": 7208,
	"./en/base.js": 7208,
	"./en/metadata": 1536,
	"./en/metadata.js": 1536,
	"./es/base": 9680,
	"./es/base.js": 9680,
	"./es/metadata": 4576,
	"./es/metadata.js": 4576,
	"./pt/base": 9328,
	"./pt/base.js": 9328,
	"./pt/metadata": 1104,
	"./pt/metadata.js": 1104
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8100;